import { logger } from '@sentry/react';
import { IHeartbeatMonitor } from './IHeartbeatMonitor';

export class PingPongHeartbeat implements IHeartbeatMonitor {
  private heartbeatInterval?: NodeJS.Timeout;
  private heartbeatTimeout?: NodeJS.Timeout;
  private timeoutCallback?: () => void;

  constructor(
    private readonly sendMessage: (message: string) => void,
    private readonly isConnected: () => boolean,
    private readonly canvasId: string,
    public intervalMs: number = 10000,
    public timeoutMs: number = 5000
  ) {}

  get isIntervalActive(): boolean {
    return this.heartbeatInterval !== undefined;
  }

  get isTimeoutActive(): boolean {
    return this.heartbeatTimeout !== undefined;
  }

  start(): void {
    this.stop();

    this.heartbeatInterval = setInterval(() => {
      if (!this.isConnected()) return;

      this.sendMessage(
        JSON.stringify({
          type: 'ping',
          data: { timestamp: Date.now() },
        })
      );

      if (this.heartbeatTimeout) return;

      // Only schedule a timeout if one isn't already running
      // This prevents multiple timeouts from accumulating
      this.heartbeatTimeout = setTimeout(() => {
        logger.warn('Heartbeat timeout - server not responding', {
          canvasId: this.canvasId,
        });
        this.timeoutCallback?.();
      }, this.timeoutMs);
    }, this.intervalMs);
  }

  stop(): void {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval);
      this.heartbeatInterval = undefined;
    }
    if (this.heartbeatTimeout) {
      clearTimeout(this.heartbeatTimeout);
      this.heartbeatTimeout = undefined;
    }
  }

  resetTimeout(): void {
    if (this.heartbeatTimeout) {
      clearTimeout(this.heartbeatTimeout);
      this.heartbeatTimeout = undefined;
    }
  }

  onTimeout(callback: () => void): void {
    this.timeoutCallback = callback;
  }
}
